import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { MdOutlineDelete, MdOutlineEdit, MdContentCopy } from 'react-icons/md'
import { useWireState } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import SearchInput from '@components/shared/SearchInput'
import { AssignToUser } from '@components/tract/AssignToUser'
import { useFilterBySearch } from '@components/shared/useFilterBySearch'
import RemoveRunsheetModal from '@components/tract/RemoveRunsheetModal'
import { RUNSHEETS_HEADERS } from '@/constants'

import CircleSpinner from '@components/shared/CircleSpinner'


import './Tracts.css'
import { BsArrowDownUp, BsSortDown, BsSortUp } from 'react-icons/bs'
import useSortableTableHeaders from '@/hook/useSortableTableHeaders'
import CollectionRunsheetPersistFlow, { STEPS } from '../shared/CollectionRunsheetPersistFlow'
import { CopyRunsheet } from './Runsheet/CopyRunsheet'

const STATUS_MAP = {
    assigned: 'Assigned',
    in_progress: 'In Progress',
    completed: 'Completed',
}

export const Runsheets = () => {
    const [showAdd, showHideAdd] = useState(false)
    const [showAssignToUser, showHideAssignToUser] = useState(false)
    const [editRunsheet, setEditRunsheet] = useState()
    const [assignRunsheets, setAssignRunsheets] = useState([])
    const [runsheets, setRunsheets] = useState([])
    const [showRemove, showHideRemove] = useState(false)
    const [loading, setLoading] = useState(false)
    const [copyRunsheetModal, setCopyRunsheetModal] = useState(false)
    // const [copyChaining, setCopyChaining] = useState(false)
    const [copyTract, setCopyTract] = useState(false)
    const [copyChaining, setCopyChaining] = useState(false)
    
    // @todo why not use only `editRunsheet` or give it a good name?
    const [runsheetId, setRunsheetId] = useState('')
    const [runsheetName, setRunsheetName] = useState('')
    const [newRunsheetName, setNewRunsheetName] = useState('')
    
    // @todo remove this workaround. this is used to refresh the runsheets after one gets deleted
    const [updateList, setUpdateList] = useState(0)
    
    const [, setRunsheet] = useWireState(store.currentRunsheet)
    const [allRunsheets, setAllRunsheets] = useWireState(store.runsheets)
    
    const {
        orderField,
        orderDirection,
        onHeaderClick,
    } = useSortableTableHeaders(Object.values(RUNSHEETS_HEADERS).filter(cf => cf.sortable).map(cf => cf.key))   
    
    const handleShowHideAssignToUser = async show => {
        showHideAssignToUser(show)
        
        if (!show) {
            setAssignRunsheets([])
        }
    }
    
    const modalHandler = () => { setCopyRunsheetModal(false) }
    
    const submitCopy = async () => {
        setLoading(true)
        modalHandler()
        await actions.copyRunsheet(runsheetId, newRunsheetName, { tracts: copyTract, chaining: copyChaining })
        setLoading(false)
    }
    
    const { search, setSearch } = useFilterBySearch(allRunsheets, runsheets, setRunsheets, ['name'])
    const [keyRunsheet, setKeyRunsheet] = useState()
    const [isSort, setIsSort] = useState(false)
    
    const compareRunsheetsUp = (runsheets1, runsheets2, key) => {
        
        if (typeof runsheets1[key] === 'string') {
            const runsheet1 = runsheets1[key].toUpperCase()
            const runsheet2 = runsheets2[key].toUpperCase()
            
            if (runsheet1 < runsheet2) {
                return -1
            }
            
            if (runsheet1 > runsheet2) {
                return 1
            }
            
            return 0
        } else {
            const runsheet1 = runsheets1[key]
            const runsheet2 = runsheets2[key]
            
            if (runsheet1 < runsheet2) {
                return -1
            }
            
            if (runsheet1 > runsheet2) {
                return 1
            }
            
            return 0
        }
    }
    
    const compareRunsheetsDown = (runsheets1, runsheets2, key) => {
        if (typeof runsheets1[key] === 'string') {
            const runsheet1 = runsheets1[key].toUpperCase()
            const runsheet2 = runsheets2[key].toUpperCase()
            
            if (runsheet1 > runsheet2) {
                return -1
            }
            
            if (runsheet1 < runsheet2) {
                return 1
            }
            
            return 0
        } else {
            const runsheet1 = runsheets1[key]
            const runsheet2 = runsheets2[key]
            
            if (runsheet1 > runsheet2) {
                return -1
            }
            
            if (runsheet1 < runsheet2) {
                return 1
            }
            
            return 0
        }
    }
    
    let isSortingRunsheet = true
    let isFirstSort = false
    
    const sortColumns = (key, key1, runsheet) => {
        
        if (key !== keyRunsheet) {
            isSortingRunsheet = true
            setIsSort(false)
            isFirstSort = true
        } else {
            isSortingRunsheet = false
            setIsSort(!isSort)
        }
        
        runsheet.forEach(runsheet => {
            if (runsheet.assignedTo.length === 0) {
                runsheet?.assignedTo.push({ id: '', firstName: '', lastName: ' ' })
            }
        })
        runsheet.forEach(runsheet => {
            if (runsheet.certDate === null) {
                runsheet.certDate = ''
            }
            
            if (runsheet.createdAt === null) {
                runsheet.createdAt = ''
            }
        })
        
        // console.log(runsheet[0][key])
        if (typeof runsheet[0][key] === 'object') {
            runsheet?.sort((runsheet, runsheet2) => {
                // console.log('runsheet,', runsheet)
                // console.log('runsheet2,', runsheet2)
                // console.log(isSortingRunsheet)
                return runsheet?.assignedTo[0]?.[key1] > runsheet2?.assignedTo[0]?.[key1] && isSortingRunsheet ? 1 : -1
            },
            )
        } else {
            if (!isFirstSort) {
                runsheet?.sort((user, runsheet2) => {
                    if (isSort) {
                        return compareRunsheetsUp(user, runsheet2, key)
                    } else {
                        return compareRunsheetsDown(user, runsheet2, key)
                    }
                })
            } else {
                runsheet?.sort((user, runsheet2) => {
                    return compareRunsheetsUp(user, runsheet2, key)
                })
            }
        }
        
        runsheet.forEach(runsheet => {
            if (runsheet.assignedTo[0]?.[key1] === '') {
                runsheet?.assignedTo.pop()
            }
        })
    }
    
    useEffect(() => {
        // clears the currentRunsheet case it exists
        setRunsheet(null)
        
        return () => {
            setAllRunsheets([])
        }
    }, [])
    
    useEffect(() => {
        setLoading(true)
        
        actions.fetchRunsheets()
            .then(() => {
                setLoading(false)
            })
        
    }, [])
    
    useEffect(() => {
        setRunsheets(allRunsheets)
    }, [allRunsheets, updateList])
    
    return (
        <div>
            <div className="mb-3 card">
                <div className="flex gap-2 py-3 px-2">
                    <SearchInput
                        className="w-full grow"
                        value={search}
                        placeholder="Search runsheets..."
                        onChange={({ target: { value } }) => setSearch(value.toLowerCase())} />
                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            setEditRunsheet(undefined)
                            showHideAdd(!showAdd)
                        }}
                        data-test-id="RunsheetsCreateRunsheetButton">
                        Create Runsheet
                    </button>
                </div>
                {loading && (
                    <div className="flex flex-col justify-center w-full">
                        <CircleSpinner className="mx-auto mt-20"/>
                    </div>
                )}
                {!loading && <div className={'runsheets-list-viewport ml-0 pt-0 pl-0 pr-0'}>
                    <table className="table table-nowrap table-pin-rows card-table">
                        <thead>
                            <tr>
                                {Object.keys(RUNSHEETS_HEADERS).map(it => {
                                    
                                    return (
                                        RUNSHEETS_HEADERS[it].sortable ?
                                            <th
                                                key={it}
                                                className="cursor-pointer sort"
                                                onClick={() => {
                                                    // console.log('it', RUNSHEETS_HEADERS.key)
                                                    if (RUNSHEETS_HEADERS[it].key === 'assignedTo') {
                                                        
                                                        sortColumns(RUNSHEETS_HEADERS[it].key, 'firstName', runsheets)
                                                        
                                                    } else {
                                                        
                                                        sortColumns(RUNSHEETS_HEADERS[it].key, '', runsheets)
                                                        
                                                    }
                                                    
                                                    setKeyRunsheet(RUNSHEETS_HEADERS[it].key)
                                                    onHeaderClick(RUNSHEETS_HEADERS[it].key)
                                                    
                                                }}
                                                data-sort={it.dataSort}>
                                                <div className="flex gap-2">
                                                    <span>{it}</span>
                                                    <span className="text-md pt-0.5 ">
                                                        {orderField !== RUNSHEETS_HEADERS[it].key && 
                                                            <BsArrowDownUp />}
                                                        {orderField === RUNSHEETS_HEADERS[it].key && (
                                                            orderDirection === 'DESC' ? <BsSortDown /> : <BsSortUp />
                                                        )}
                                                    </span>
                                                </div>
                                            </th> : <th key={it}>{it}</th>
                                    )
                                })}
                                <th></th>
                            </tr>
                        </thead>
                        <tbody className="list">
                            {runsheets.map((runsheet, i) => (
                                <tr key={i}>
                                    <td className="align-middle">
                                        <Link to={`/runsheet/${runsheet.id}`}>{runsheet.name}</Link>
                                    </td>
                                    <td className="align-middle">{runsheet.numOfDocs || 0}</td>
                                    {/* <td className="align-middle">{runsheet.grossAcreage} Acres</td> */}
                                    <td className="align-middle">{`${
                                        runsheet.assignedTo && runsheet.assignedTo?.length
                                            ? runsheet.assignedTo.map(it => it.firstName).join(', ')
                                            : ''
                                    }`}</td>
                                    <td className="align-middle">{STATUS_MAP[runsheet?.status]}</td>
                                    <td className="align-middle">{runsheet.statusDate?.split('T')[0]}</td>
                                    <td className="align-middle">{runsheet.certDate?.split('T')[0]}</td>
                                    <td className="align-middle">
                                        <div className="flex gap-2">
                                            <MdOutlineEdit
                                                data-tooltip-id="default-tip"
                                                data-tooltip-content="Edit"
                                                className="text-lg cursor-pointer"
                                                onClick={() => {
                                                    setEditRunsheet(runsheet)
                                                    showHideAdd(!showAdd)
                                                }} />
                                            <MdContentCopy 
                                                data-tooltip-id="default-tip"
                                                data-tooltip-content="Copy Runsheet"
                                                className="text-lg cursor-pointer"
                                                onClick={() => {
                                                    setRunsheetId(runsheet.id || '')
                                                    setNewRunsheetName(`${runsheet.name} (copy)`)
                                                    setCopyRunsheetModal(true)
                                                }}/>
                                            <MdOutlineDelete
                                                data-tooltip-id="default-tip"
                                                data-tooltip-content="Delete"
                                                className="text-lg cursor-pointer"
                                                onClick={() => {
                                                    showHideRemove(true)
                                                    setRunsheetId(runsheet.id || '')
                                                    setRunsheetName(runsheet.name || '')
                                                }} 
                                                data-test-id="RunsheetRowDeleteButton"/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>}
            </div>
            {showAssignToUser && (
                <AssignToUser
                    showAdd={showAssignToUser}
                    showHideAdd={handleShowHideAssignToUser}
                    selectedModelIds={assignRunsheets.map(({ id }) => id || '')}
                    assignedToIds={
                        (assignRunsheets.length === 1 && assignRunsheets[0]?.assignedTo?.map(({ id }) => id)) || []  
                    }
                    which="Runsheet"
                    setIsAssigned={() => {}} /> 
                
            )} 
            {showAdd && (
                <CollectionRunsheetPersistFlow
                    setEditDialogOpen={showHideAdd}
                    initialData={editRunsheet}
                    initialStep={STEPS.RUNSHEET}/>
            )}
            {showRemove && (
                <RemoveRunsheetModal
                    showRemove={showRemove}
                    showHideRemove={showHideRemove}
                    id={runsheetId}
                    name={runsheetName}
                    updateList={updateList}
                    setUpdateList={setUpdateList} />
            )}
            {copyRunsheetModal && (
                <CopyRunsheet
                    copyRunsheetModal={copyRunsheetModal}
                    modalHandler={modalHandler}
                    submitCopy={submitCopy}
                    newRunsheetName={newRunsheetName}
                    setNewRunsheetName={setNewRunsheetName}
                    copyTract={copyTract}
                    setCopyTract={setCopyTract}
                    copyChaining={copyChaining}
                    setCopyChaining={setCopyChaining}/>
            )}
        </div>
    )
}
